import React from 'react';
import './StatusMessage.css';

// Loading, empty and error states for a page or panel.
const StatusMessage = ({ kind, children, onRetry }) => {
  if (kind === 'loading') {
    return (
      <div className="status-message" aria-busy="true">
        <div className="spinner" />
        {children && <span>{children}</span>}
      </div>
    );
  }
  if (kind === 'error') {
    return (
      <div className="error-banner status-error" role="alert">
        <span>{children}</span>
        {onRetry && (
          <button type="button" className="link-button" onClick={onRetry}>Try again</button>
        )}
      </div>
    );
  }
  return <div className="status-message status-empty">{children}</div>;
};

export default StatusMessage;
